(function () {
  function wireGift(root) {
    if (!root) return;
    var checkbox = root.querySelector('#attr-gift');
    var panel    = root.querySelector('#attr-gift-panel');
    var msg      = root.querySelector('#attr-gift-message');
    var countEl  = root.querySelector('#attr-gift-count');

    function updateCount() {
      if (!msg || !countEl) return;
      var max  = parseInt(msg.getAttribute('maxlength') || '250', 10);
      var used = (msg.value || '').length;
      countEl.textContent = used + ' of ' + max;
    }

    function toggle() {
      if (!checkbox || !panel) return;
      var show = checkbox.checked;
      panel.style.display = show ? 'block' : 'none';
      checkbox.setAttribute('aria-expanded', show ? 'true' : 'false');
      if (!show && msg) { msg.value = ''; updateCount(); }
    }

    if (checkbox) checkbox.addEventListener('change', toggle);
    if (msg)      msg.addEventListener('input', updateCount);

    toggle();
    updateCount();
  }

  // Initial bind
  document.addEventListener('DOMContentLoaded', function () {
    wireGift(document.querySelector('.cart-gift'));
  });

  // If your cart re-renders via AJAX, listen for a refresh event or re-bind on mutation
  var mo = new MutationObserver(function () {
    var root = document.querySelector('.cart-gift');
    if (root) wireGift(root);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
